import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

// The DatePicker holds a bare calendar day as a local-midnight Date; serialize it as the picked day.
// The backend anchors this day to the account timezone on save (see src/utils/promotionDate.ts).
export const toPromotionDayString = (date: Date): string => format(date, 'yyyy-MM-dd');

// Rebuild the DatePicker value from a stored UTC instant so it shows the account-timezone calendar day.
export const fromStoredPromotionDay = (
  value: Date | string | null | undefined,
  timezone: string,
): Date | null => {
  if (!value) return null;
  const day = formatInTimeZone(new Date(value), timezone, 'yyyy-MM-dd');
  return new Date(`${day}T00:00:00`);
};

// The stored instant's calendar day in the account timezone, as `yyyy-MM-dd`.
export const storedPromotionDayString = (
  value: Date | string | null | undefined,
  timezone: string,
): string | undefined => (value ? formatInTimeZone(new Date(value), timezone, 'yyyy-MM-dd') : undefined);
